import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/gfx-clients.jpg'
import _imports_1 from '../assets/img/clients/OldMutual.jpg'
import _imports_2 from '../assets/img/clients/nedbank.jpg'
import _imports_3 from '../assets/img/clients/spot-money.png'
import _imports_4 from '../assets/img/clients/nandos.jpg'
import _imports_5 from '../assets/img/clients/investec.jpg'
import _imports_6 from '../assets/img/clients/freedthinkers.gif'
import _imports_7 from '../assets/img/clients/Standard-Chartered-Bank.jpg'
import _imports_8 from '../assets/img/clients/stoneHouse.jpg'
import _imports_9 from '../assets/img/clients/tsiba.jpg'
import _imports_10 from '../assets/img/clients/brait.jpg'
import _imports_11 from '../assets/img/clients/transunion.gif'
import _imports_12 from '../assets/img/clients/equity-africa.jpg'
import _imports_13 from '../assets/img/clients/department_sports_arts.png'
import _imports_14 from '../assets/img/clients/Department-public.jpg'
import _imports_15 from '../assets/img/clients/credo-capital.jpg'
import _imports_16 from '../assets/img/clients/open-africa.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "970",
  height: "252"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "main-content" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Clients"),
  /*#__PURE__*/_createElementVNode("div", { id: "clients" }, [
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("table", {
      width: "100%",
      border: "0",
      cellpadding: "12",
      cellspacing: "0"
    }, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://www.oldmutual.com/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_1,
              width: "160",
              height: "60"
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "https://personal.nedbank.co.za/home.html",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_2,
              width: "160",
              height: "79"
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "https://spotmoney.com/",
            target: "_blank",
            rel: "noopener noreferrer",
            style: {"background-color":"black"}
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_3,
              width: "117",
              height: "68"
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://nandos.co.za/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_4,
              width: "160",
              height: "83"
            })
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://www.investec.co.za/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_5,
              width: "160",
              height: "41"
            })
          ]),
          /*#__PURE__*/_createElementVNode("a", { href: "http://brait.co.za/" })
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://www.freedthinkers.com/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_6,
              width: "160",
              height: "31"
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://www.standardchartered.com/home/en/index.html",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_7,
              width: "160",
              height: "65"
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://www.stonehousecapital.co.za/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_8,
              width: "160",
              height: "78"
            })
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://www.tsiba.org.za/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_9,
              width: "160",
              height: "107"
            })
          ]),
          /*#__PURE__*/_createElementVNode("a", { href: "http://www.stonehousecapital.co.za/" })
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://brait.co.za/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_10,
              width: "156",
              height: "133"
            })
          ]),
          /*#__PURE__*/_createElementVNode("a", { href: "http://www.virginmoney.co.za/vmsa/" })
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://www.transunion.co.za/home.html",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_11,
              width: "160",
              height: "59"
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://www.tsiba.org.za/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_12,
              width: "89",
              height: "78"
            })
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "https://www.dsac.gov.za/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              width: "160",
              height: "56"
            })
          ]),
          /*#__PURE__*/_createElementVNode("a", { href: "http://www.transunion.co.za/home.html" })
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://www.dpe.gov.za/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_14,
              width: "160",
              height: "63"
            })
          ]),
          /*#__PURE__*/_createElementVNode("a", { href: "http://www.standardchartered.com/home/en/index.html" })
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_15,
            target: "_blank",
            rel: "noopener noreferrer"
          })
        ]),
        /*#__PURE__*/_createElementVNode("td", { align: "center" }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "http://www.openafrica.org/",
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_16,
              width: "160",
              height: "94"
            })
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Examples of previous engagements ")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Development of Sustainable Banking Business Model."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Facilitated Big 4 SA Retail Bank Administrative Platform strategy discussion."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Asset Management Group – development of wealth management strategy."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Unit trust Linked Product turnaround strategy and implementation."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Presentation and strategy facilitation of Broker Dealer business."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Indexation Based Asset Management Business Model."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Acted as CEO in financial services turnaround. "),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Strategy development, distribution model and market assessment for new entrant to SA."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Restructure of retail bank operations."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Business plan for State Owned Enterprises."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" World Heritage Tourism initiave including financial plan."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Audit of Corporate Social Investment including financial."),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, "Stress management programmes – various.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}